import React from 'react';
import {Container, Spinner} from 'react-bootstrap';

interface ILoadingSpinnerProps {
    t: (key: string) => string;
}

export const LoadingSpinner: React.FC<ILoadingSpinnerProps> = ({t}) => (
    <Container className="w-80 d-flex justify-content-center align-items-start" style={{paddingTop: "20vh"}}>
        <Spinner animation="border" role="status" className="me-3">
            <span className="visually-hidden">Loading...</span>
        </Spinner>
        <span>{t("Loading")}</span>
    </Container>
);
